export default "/images/9b4a4ddb3dda5c76f61e38c1c3374305.avif";